module.exports = __webpack_public_path__ + "fonts/iconfont.2bb55dd.woff";